import classNames from 'classnames';
import styles from './ArticleMedia.module.scss';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';

export interface ArticleMediaProps {
	className?: string;
	image: {
		url: string;
		focalPoint?: { left: number; top: number };
		extension?: string;
	};
	caption?: string;
	altText?: string;
	disableCropping?: boolean;
}

export const UI_ArticleMedia = ({ className, image, caption, altText, disableCropping }: ArticleMediaProps) => (
	<figure className={classNames(styles.ArticleMedia, className)}>
		{image && (
			<span className={styles.ArticleMedia_mediabox}>
				<UI_Picture focalPoint={image.focalPoint} url={image.url} altText={altText} imageCropping={disableCropping ? 'contain' : 'cover'} />
			</span>
		)}
		{caption && <figcaption className={styles.ArticleMedia_caption}>{caption}</figcaption>}
	</figure>
);
